import { useEffect, useState } from 'react'
import OutlinedInput from '@mui/material/OutlinedInput'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import './multiSelectDropdown.scss'

const ITEM_HEIGHT = 40
const VISIBLE_ITEMS = 3
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * VISIBLE_ITEMS,
      overflowY: 'auto', // Ensure scrollbar appears if necessary
      width: 490,
      minWidth: 0,
      marginTop: 15,
      fontSize: '13px',
      fontFamily: 'Montserrat Medium',
      borderRadius: '5px',
    },
    className: 'multi-dropdown-paper',
  },
}
const MenuBatchProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * VISIBLE_ITEMS,
      overflowY: 'auto', // Ensure scrollbar appears if necessary
      width: 490,
      minWidth: 0,
      // marginTop: 15,
      fontSize: '13px',
      fontFamily: 'Montserrat Medium',
      borderRadius: '5px',
    },
    className: 'multi-dropdown-paper',
  },
}

export default function MultiSelectDropdown({ disabled, name, placeholder, selectedValue, options, onChange, className }) {
  const [selectedItems, setSelectedItems] = useState(selectedValue || [])
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setSelectedItems(selectedValue || [])
  }, [selectedValue])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event
    const newValue = typeof value === 'string' ? value?.split(',') : value
    setSelectedItems(newValue)
    onChange(newValue)
  }

  return (
    <div className='mselect-dropdown'>
      <FormControl>
        <Select
          multiple
          displayEmpty
          value={selectedItems}
          name={name}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em className='mselect-dropdown-placeholder'>{placeholder}</em>
            }
            if (selected.length === 1) {
              const option = options.find((opt) => opt.value === selected[0])
              return option ? option.label : selected[0]
            }
            const firstOption = options.find((opt) => opt.value === selected[0])
            return `${firstOption ? firstOption.label : selected[0]} + ${selected.length - 1}`
          }}
          // renderValue={(selected) => {
          //   if (selected?.length === 0) {
          //     return <em className='mselect-dropdown-placeholder'>{placeholder}</em>
          //   }
          //   return selected
          //     ?.map((value) => {
          //       const option = options?.find((opt) => opt?.value === value)
          //       return option ? option?.label : value
          //     })
          //     .join(', ')
          // }}
          MenuProps={name == 'batchDropdown' ? MenuBatchProps : MenuProps}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          disabled={disabled}
          sx={{"&.MuiMenu-paper": {marginTop: 0}}}
        >
          {!isOpen && selectedItems?.length === 0 && (
            <MenuItem disabled value=''>
              <em>{placeholder}</em>
            </MenuItem>
          )}
          {options?.map((option) => (
            <MenuItem key={option?.value} value={option?.value}>
              <Checkbox checked={selectedItems?.indexOf(option?.value) > -1} />
              <ListItemText primary={option?.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}
